import { render, staticRenderFns } from "./IrisIcon.vue?vue&type=template&id=9a10efbc&"
import script from "./IrisIcon.vue?vue&type=script&lang=ts&"
export * from "./IrisIcon.vue?vue&type=script&lang=ts&"
import style0 from "./IrisIcon.vue?vue&type=style&index=0&id=9a10efbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports